// track-wave-row — 53-я wave cell (sibling to track-row in split-column model).
//
// Renders one .tr-wave-row in .rh-waves > .rh-tracks-body. SVG per-track
// waveform via drawSymRibbon primitive. Pairs with controls .tr-row via
// matching --track-index CSS property.
//
// PerTrackSummaryPeaks.tracks shape: Record<string, number[]> — direct bins
// array (no .bins wrapper). Bins are number[] (0..1 range already normalized).
//
// DOM structure:
//   .tr-wave-row  [data-track-id] [--track-index] [.is-empty?]
//   └── <svg class="tr-mini-wave">  (when peaks present)

import type { ShareManifest } from '@bandway/share-types';
import { drawSymRibbon } from '@bandway/ui-primitives';
import type { Player } from '../player.js';

type Track = ShareManifest['tracks'][number];

export interface TrackWaveRowHandle {
  unmount: () => void;
}

const W = 1000;
const H = 80;

export function mountTrackWaveRow(
  host: Element,
  track: Track,
  _player: Player,
  trackIndex: number,
  perTrackBins: number[] | null,
): TrackWaveRowHandle {
  const row = document.createElement('div');
  row.className = 'tr-wave-row';
  row.dataset.trackId = track.id;
  row.style.setProperty('--track-index', String(trackIndex));

  if (!perTrackBins || perTrackBins.length === 0) {
    row.classList.add('is-empty');
  } else {
    const tmp = document.createElement('div');
    tmp.innerHTML = drawSymRibbon(perTrackBins, {
      width: W,
      height: H,
      fillStyle: track.color,
      barWidth: 2,
      barGap: 1,
    });
    const svg = tmp.querySelector('svg');
    if (svg) {
      svg.setAttribute('class', 'tr-mini-wave');
      row.appendChild(svg);
    }
  }

  host.appendChild(row);

  return {
    unmount: () => {
      try { host.removeChild(row); } catch { /* best-effort */ }
    },
  };
}
